import type { SwitchProps } from './Switch';

export type OldSwitchProps = Omit<SwitchProps, 'checked' | 'onChange'> & {
  /** @deprecated checked를 대신 사용해주세요. */
  isOn?: boolean;
};

export function convertOldSwitchProps(props: OldSwitchProps): SwitchProps {
  const { isOn, ...restProps } = props;

  return {
    ...restProps,
    checked: isOn,
  };
}
